const getDefaultBillingInfo = (data) => {
  return {
    billToCode: data?.billToCode ?? "",
    billToName: data?.billToName ?? "",
    quoteNumber: data?.quoteNumber ?? "",
    referenceNumber: data?.pickupReferenceNumber ?? "",
  };
};

export { getDefaultBillingInfo };
